import { render } from "./wallet-view-option-modal.vue?vue&type=template&id=03e8c888&scoped=true&ts=true"
import script from "./wallet-view-option-modal.vue?vue&type=script&lang=ts"
export * from "./wallet-view-option-modal.vue?vue&type=script&lang=ts"

import "./wallet-view-option-modal.vue?vue&type=style&index=0&id=03e8c888&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e8c888"]])

export default __exports__